import Vue from "vue";
import { events } from "./events.js";
import store from "@/store";
import Notifier from "@/components/Notifier.vue";
import router from "../router";
import { NOTIFICATION_TYPES } from "../utilities/enums";

var tag = 0;
var desktopNotificationObject;
var icon = "./notification-dealio-ico.ico";
var badge = "./notification-dealio-white.png";

const NotifierPlugin = {
  install: function(Vue, options) {
    options = options || {};

    Vue.component("notifier", Notifier);

    Vue.prototype.$notifier = {
      success(message, options) {
        notificationCallHandler(message, options, "primary", "success");
      },
      info(message, options) {
        notificationCallHandler(message, options, "info", "info");
      },
      warn(message, options) {
        notificationCallHandler(message, options, "secondary", "warning");
      },
      error(message, options) {
        if (!showThisNotification("error")) return;
        if (options && options.error) {
          if (options.error.response) {
            let response = options.error.response;

            if (response.data && (response.data.violations || response.data.message))
              message = createViolationsMessage(response);

            if (store.getters.isAdmin && response.status)
              message += `. Status ${response.status}`;
          }
          options.error = null; // Clear
        }
        notificationCallHandler(message, options, "error");
      },
      notify(message, options) {
        let show = false;
        switch (options.color) {
          case "primary":
            if (showThisNotification("success")) show = true;
            break;
          case "error":
            if (showThisNotification("error")) show = true;
            break;
          case "secondary":
            if (showThisNotification("warning")) show = true;
            break;
          case "info":
            if (showThisNotification("info")) show = true;
            break;
          default:
            0;
        }
        if (show) {
          if (pageIsHidden()) {
            showDeviceNotification(message, options);
          } else {
            events.$emit("notify", {
              message: message,
              ...options,
            });
          }
        }
      },
    };
  },
};

var pushNotificationPage = { location: "", handled: false };

function showDeviceNotification(message, options) {
  if (
    options == undefined ||
    (typeof options == "object" && !options.hasOwnProperty("type"))
  ) {
    options = { type: NOTIFICATION_TYPES.DEFAULT };
  }
  if (deviceNotificationsEnabled()) {
    if (!options.goToPage || options.goToPage == undefined) {
      options.goToPage = "/";
    }
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        let text = message.replace(/\|/g, " ");
        isDesktop()
          ? desktopNotification(text, options)
          : mobileNotification(text, options);
      }
    }
  }
}

function desktopNotification(text, options) {
  if (
    typeof desktopNotificationObject === "object" &&
    typeof desktopNotificationObject.close === "function"
  ) {
    // Close the currently showing notification
    desktopNotificationObject.close();
  }
  // Show the new notification
  let settings = {
    body: text,
    icon: icon,
    badge: badge,
    data: {
      url: options.goToPage,
      originUrl: window.location.origin,
    },
    tag: tag++,
  };
  // addExtraData(settings.data, options);
  desktopNotificationObject = new Notification("Dealio", settings);

  desktopNotificationObject.onclick = (event) => {
    window.focus();
    if (options.type == NOTIFICATION_TYPES.TW_ALERT) {
      events.$emit("focus-on-new-alert", options.alertId);
    } else if (window.location.pathname != options.goToPage) {
      if (options.goToPage != "/") router.push(options.goToPage);
    }
  };
}

function mobileNotification(text, options) {
  navigator.serviceWorker.ready.then(function(registration) {
    const settings = {
      body: text,
      icon: icon,
      badge: badge,
      vibrate: [200, 50, 200],
      data: {
        url: options.goToPage,
        originUrl: window.location.origin,
      },
      actions: [
        { action: "check", title: "Check" },
        { action: "close", title: "Ignore" },
      ],
      tag: updateSameType() ? options.type : tag++,
      renotify: renotify(),
    };
    addExtraData(settings.data, options);
    registration.showNotification("Dealio", settings);
  });
}

// Helper Functions

function createViolationsMessage(response) {
  if (response.data.message) return response.data.message;

  let violations = response.data.violations;
  let message = `Violation${violations.length > 1 ? "s" : ""}:<br/>`;
  violations.forEach((violation, i) => {
    if (violations.length > 1) {
      message += `${i + 1}. `;
    }
    message += `${violation.message}`;
    if (violations.length > 1 && i + 1 != violations.length) {
      message += "<br/>";
    }
  });

  return message;
}

function notificationCallHandler(message, options, color, type) {
  if (type) if (!showThisNotification(type)) return;
  
  if (pageIsHidden()) {
    showDeviceNotification(message, options);
  } else {
    events.$emit("notify", {
      message: message,
      color: color,
      ...options,
    });
  }
}

function renotify() {
  if (store.state.settings.general.notifications.renotify == undefined)
    return true;
  else return store.state.settings.general.notifications.renotify;
}

function updateSameType() {
  if (store.state.settings.general.notifications.updateSameType == undefined)
    return true;
  else return store.state.settings.general.notifications.updateSameType;
}

function deviceNotificationsEnabled() {
  return store.state.settings.general.notifications.enable;
}

function addExtraData(currentData, options) {
  switch (options.type) {
    case NOTIFICATION_TYPES.PG_EVENT:
      currentData.actionData = { type: "change-route", route: "/price-guard" };
      break;
    case NOTIFICATION_TYPES.TW_ALERT:
      currentData.actionData = { type: "tw-alert", alertId: options.alertId };
      break;
  }
}

function isDesktop() {
  return (
    navigator.userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i
    ) == null
  );
}

function pageIsHidden() {
  return (
    document.hidden ||
    document.msHidden ||
    document.webkitHidden ||
    document.mozHidden
  );
}

function showThisNotification(type) {
  return store.state.settings.general.notifications[type];
}

// Close the last notification before unloading
// it's important because the next notification with the same tag will not be shown to the user
window.addEventListener("beforeunload", function() {
  if (typeof desktopNotificationObject === "object") {
    desktopNotificationObject.close();
  }
});

Vue.use(NotifierPlugin);
export default pushNotificationPage;
